<script setup lang="ts">
defineProps({ blok: Object })

const localePath = useLocalePath()
</script>

<template>
    <section class="relative py-12 overflow-hidden">
        <UiContainer max-width="max-w-3xl" class="relative">
            <img v-motion-slide-visible-once-left src="https://a.storyblok.com/f/291812700015950/213x213/0657a14f5f/home-hero-01.png" class="absolute right-full -top-32" />
            <img v-motion-slide-visible-once-right src="https://a.storyblok.com/f/291812700015950/386x386/9432186a08/home-hero-02.png" class="absolute right-full top-1/8 translate-x-[-100px]" />
            <img v-motion-slide-visible-once-top src="https://a.storyblok.com/f/291812700015950/213x213/a2b19677be/home-hero-03.png" class="absolute right-full top-9/12 translate-x-[100px]" />
            <img v-motion-slide-visible-once-right src="https://a.storyblok.com/f/291812700015950/420x420/95d7cfc1ea/home-hero-04.png" class="absolute -top-10 right-full left-full" />
            <img v-motion-slide-visible-once-bottom src="https://a.storyblok.com/f/291812700015950/354x354/1792ea2734/home-hero-05.png" class="absolute right-full top-2/3 left-full translate-x-[-50px]" />
            <div class="text-center mb-4 [&>p]:font-medium [&>p]:fs-4xl [&>p]:font-eb-garamond [&>p]:text-chsc-yellow  [&>p>strong]:font-medium [&>p>strong]:text-chsc-indigo-500">
                    <StoryblokRichText
                        :doc="blok?.edition"
                    />
                </div>
                <div class="my-14">
                <img
                    v-motion-slide-top
                    class="mb-4 w-full max-w-full"
                    :src="blok?.header.filename"
                >
                </div>
                <div class="flex justify-center">
                    <UButton
                        :to="localePath('/scorecards')"
                        :label="blok?.cta"
                        size="xl"
                    />
                </div>
                
        </UiContainer>
    </section>
</template>
